import React from 'react';

interface StretchyParenthesesProps {
    height: number;
    side: 'left' | 'right';
    strokeWidth?: number;
}

const StretchyParentheses: React.FC<StretchyParenthesesProps> = ({
    height,
    side,
    strokeWidth = 1.5,
}) => {
    // Determines how "curved" the parentheses are -- more curve needed for taller parentheses
    let controlOffset = 2;
    if (height > 60) controlOffset = 4;
    if (height > 100) controlOffset = 6;
    if (height > 150) controlOffset = 8;

    const path =
        side === 'left'
            ? `M8,1 Q${0 - controlOffset},${height / 2} 8,${height - 1}`
            : `M0,1 Q${8 + controlOffset},${height / 2} 0,${height - 1}`;

    return (
        <svg
            width="10"
            height={height}
            viewBox={`0 0 8 ${height}`}
            style={{ verticalAlign: 'middle', overflow: 'visible' }}
        >
            <path
                d={path}
                fill="none"
                stroke="black"
                strokeWidth={strokeWidth}
                strokeLinecap="round"
            />
        </svg>
    );
};

export default StretchyParentheses;
